import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark} from '@fortawesome/free-solid-svg-icons'

export const EnableDisableBtn = ({status, handleApprovedAndUnAprooved, statusId}) => {

    return(
        <React.Fragment>
           <div className="custom-button">
            { status === false ? <button className="approved-btn" onClick={() => handleApprovedAndUnAprooved(statusId)} ><FontAwesomeIcon icon={faCircleCheck} /> Enable</button>  : <button className="unapproved-btn" onClick={() => handleApprovedAndUnAprooved(statusId)} > <FontAwesomeIcon icon={faCircleXmark} /> Disable</button>  }            
           </div>
        </React.Fragment>
    )
}